import { IoSearch } from "react-icons/io5";
import { useLanguage } from "../Context";

export default function AdminSearch({
  handleSearchSubmit,
  searchQuery,
  handleSearchInputChange,
  setShowResults,
  resultRef,
}) {
  const { language } = useLanguage();

  return (
    <div className="d-flex justify-content-end my-2 me-2">
      <form className="d-flex align-items-center" onSubmit={handleSearchSubmit}>
        <div className="input-group">
          <button
            className="btn btn-warning"
            onClick={() => setShowResults((prev) => !prev)}
            ref={resultRef}
            type="submit"
          >
            {parseInt(language) === 1 ? "جستجو" : "لټون."}
          </button>
          <input
            type="search"
            className="form-control border-end-0"
            placeholder={parseInt(language) === 1 ? "جستجو..." : "لټون..."}
            value={searchQuery}
            onChange={handleSearchInputChange}
            required
            dir="rtl"
          />
          <span className="input-group-text bg-white border-start-0">
            <IoSearch style={{ width: "1.75rem", height: "1.75rem" }} />
          </span>
        </div>
      </form>
    </div>
  );
}
